import { useState } from "react";
import { F, D } from "../../../styles/palette";
import AdminDashboard from "./AdminDashboard";
import AdminDoctors from "./AdminDoctors";
import AdminUsers from "./AdminUsers";
import AdminAuditLog from "./AdminAuditLog";
import AdminIntegrity from "./AdminIntegrity";

const SUBTABS = [
  { id: "dash", l: "Dashboard", i: "\ud83d\udcca" },
  { id: "docs", l: "M\u00e9dicos", i: "\ud83d\udc68\u200d\u2695\ufe0f" },
  { id: "users", l: "Usuarios", i: "\ud83d\udc65" },
  { id: "audit", l: "Auditor\u00eda", i: "\ud83d\udccb" },
  { id: "integ", l: "Integridad", i: "\ud83d\udd12" },
];

export default function AdminModule({ user }) {
  const [tab, setTab] = useState("dash");

  if (user?.role !== "admin") {
    return (
      <div style={{ background: "rgba(220,38,38,0.08)", border: "1px solid rgba(220,38,38,0.3)", borderRadius: 12, padding: 30, textAlign: "center" }}>
        <div style={{ fontSize: 40, marginBottom: 10 }}>&#128274;</div>
        <h3 style={{ color: "#fca5a5", fontSize: 16, margin: "0 0 8px", fontFamily: F.b }}>Acceso denegado</h3>
        <p style={{ color: "#64748b", fontSize: 13 }}>Solo los administradores pueden acceder a este modulo.</p>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: "flex", gap: 4, marginBottom: 16, flexWrap: "wrap" }}>
        {SUBTABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{
              padding: "8px 14px", borderRadius: 8,
              border: `1px solid ${tab === t.id ? D.ac : "rgba(100,116,139,0.12)"}`,
              background: tab === t.id ? "rgba(45,212,191,0.1)" : "transparent",
              color: tab === t.id ? D.ac : "#64748b",
              fontSize: 12, fontWeight: tab === t.id ? 700 : 500,
              cursor: "pointer", fontFamily: F.b,
            }}>
            <span style={{ marginRight: 4 }}>{t.i}</span>{t.l}
          </button>
        ))}
      </div>

      {tab === "dash" && <AdminDashboard user={user} />}
      {tab === "docs" && <AdminDoctors user={user} />}
      {tab === "users" && <AdminUsers user={user} />}
      {tab === "audit" && <AdminAuditLog user={user} />}
      {tab === "integ" && <AdminIntegrity user={user} />}
    </div>
  );
}
